import Typography from '@mui/material/Typography';
import { FC } from 'react';

import GenericLayout from '../components/generic-layout/GenericLayout';
import { H2 } from '../components/heading/Hx';
import Paragraph from '../components/paragraph/Paragraph';
import Route from '../components/route/Route';
import NoPageImageSection from '../components/section/NoPageImageSection';
import { useConfigContext } from '../context/ConfigContext';
import { COLOR } from '../theme/type';

const Kontakt: FC = () => {
  const { company } = useConfigContext();

  return (
    <GenericLayout title='Kontakt'>
      <NoPageImageSection>
        <H2 center color={COLOR.Gold1}>
          Nimm Kontakt mit uns auf
        </H2>
        <Paragraph center>
          <Typography component='span' sx={{ display: 'block' }}>
            Einfach per Telefon:
          </Typography>
          <Route href={`tel:${company.phone}`}>{company.phoneText}</Route>
        </Paragraph>
        <Paragraph center>
          <Typography component='span' sx={{ display: 'block' }}>
            Oder schreib uns per E-Mail:
          </Typography>
          <Route href={`mailto:${company.email}`}>{company.email}</Route>
        </Paragraph>
      </NoPageImageSection>
    </GenericLayout>
  );
};

export default Kontakt;
